export default __webpack_public_path__ + "media/images/mailer/wordmark-6bf690335742e60d37589df50b732185.png";